module.exports = __webpack_public_path__ + "static/media/snort-logo.c8e41386.png";